import React from 'react'

import {
  Dropdown,
  Icon,
  LogoImage,
  ToolbarButton,
  useMediaQueryContext,
} from '@fourthwall/components'
import { DotsHorizontalIcon, NewWindowIcon } from '@fourthwall/icons'

import * as S from './ConnectedSitesListItem.styled'
import type { ConnectedSite } from './ConnectedSitesListItem.types'

type ConnectedSiteListItemProps = {
  connectedSite: ConnectedSite
}

export const ConnectedSiteListItem = ({ connectedSite }: ConnectedSiteListItemProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <S.LeftSide>
        <LogoImage
          logo={connectedSite.image}
          logoBackground={connectedSite.background}
          placeholder={connectedSite.title.charAt(0)}
          size={media.tablet ? 'large' : 'medium'}
        />
        <div>
          <S.Title>
            {connectedSite.title}
            <S.Href
              href={connectedSite.href}
              target="_blank"
              title={`Open ${connectedSite.title} in new window`}
            >
              <Icon component={NewWindowIcon} height={12} />
            </S.Href>
          </S.Title>
          {connectedSite.description && <S.Description>{connectedSite.description}</S.Description>}
        </div>
      </S.LeftSide>
      <S.RightSide>
        <div>
          <Dropdown
            content={<Dropdown.Item label="Manage" onClick={connectedSite.onManage} />}
            position="bottom-end"
          >
            <ToolbarButton icon={DotsHorizontalIcon} />
          </Dropdown>
        </div>
      </S.RightSide>
    </S.Container>
  )
}
